module.exports = function() {
  return new Worker(__webpack_public_path__ + "f5533273f1ec8bde6741.worker.js");
};